import React, { useContext,useState} from "react";
import {Select,Pagination} from "antd"
import {AppTableContext} from "./AppTableProvider"

export interface AppPaginationProps {
  current:number;
  pageSize:number;
  total:number;
}

export const defaultPagination:AppPaginationProps = {
  current:1,
  pageSize:20,
  total:0
}

export const AppPagination = (props:AppPaginationProps) =>{

  const {hanldPagination} = useContext(AppTableContext);
  const {total} = props
  const [current,setCurrent] = useState(props.current);
  const [pageSize,setPageSize] = useState(props.pageSize)


  const handleCurrentChange=(pageNumber:number)=> {
        if(props.current === pageNumber) return;
        hanldPagination(pageNumber,pageSize);
        setCurrent(pageNumber);
    }

  const handlePageSizeChange = (newPageSize:number) => {
      if(props.pageSize === newPageSize) return;
      hanldPagination(current,newPageSize);
      setPageSize(newPageSize);
  }


  return  (<div className="app-table-pagination-container">
            <div className="app-table-pagination">
              <div className="app-table-pagination-left">
                <span style={{marginRight:10}}>{`共 ${total} 条`}</span>
                <Select value={pageSize} 
                        style={{width:110}} 
                        onChange={(newPageSize:number)=>handlePageSizeChange(newPageSize)}
                >
                  <Select.Option value={10}>10 条/页</Select.Option>
                  <Select.Option value={20}>20 条/页</Select.Option>
                  <Select.Option value={50}>50 条/页</Select.Option>
                  <Select.Option value={100}>100 条/页</Select.Option>
                </Select>
              </div>
              <div className="app-table-pagination-right">
                <Pagination showQuickJumper 
                current={current} 
                total={total} 
                pageSize={pageSize} 
                onChange={(pageNumber:number) => handleCurrentChange(pageNumber)} />
              </div>
            </div>
        </div>)

}





// WEBPACK FOOTER //
// ./src/qcc/AppTable/AppPagination.tsx